import { render, staticRenderFns } from "./NoTripsSection.vue?vue&type=template&id=7d67f04c&scoped=true&"
import script from "./NoTripsSection.vue?vue&type=script&lang=ts&"
export * from "./NoTripsSection.vue?vue&type=script&lang=ts&"
import style0 from "./NoTripsSection.vue?vue&type=style&index=0&id=7d67f04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d67f04c",
  null
  
)

export default component.exports